import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as DeveloperActions from 'app/developer-v3/Actions';
import * as EnvironmentVariable from 'app/entities/EnvironmentVariable';
import Domains from 'app/developer-v3/pages/embed/settings/Domains/Domains';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import {
  currentAppEntity,
  lifecycleHasFailed,
  lifecycleHasFinished,
  lifecycleHasStarted,
  versionEnvironmentVariables,
} from 'app/developer-v3/selectors';
import { createPartnerUserInteractionEventTracker } from 'app/developer-v3/teams/team-partner-sharing/createInteractionTracker';

import type { StringMap } from 'app/common/types';

const mapStateToProps = state => {
  const isSaving =
    lifecycleHasStarted(state) &&
    !(lifecycleHasFinished(state) || lifecycleHasFailed(state));

  const appEntity = currentAppEntity(state);
  const slug = CliApp.selectors.slug(appEntity);
  const trackInteraction = createPartnerUserInteractionEventTracker(state);
  const appId = CliApp.selectors.id(appEntity);
  const envVars = versionEnvironmentVariables(state);
  const isLoadingApp = CliApp.selectors.isLoading(appEntity);
  const isLoadingEnvVars = EnvironmentVariable.selectors.all.isLoading(state);

  return {
    appId,
    isLoading: isLoadingApp || isLoadingEnvVars,
    isSaving,
    initialEnvVars: envVars,
    trackInteraction,
    slug,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    const { id, version } = props.params;
    dispatch([
      DeveloperActions.loadAppAndVersion(id, version),
      DeveloperActions.loadEnvironmentForVersion(),
    ]);
  },
  async saveEnv(env: StringMap) {
    await dispatch(DeveloperActions.batchUpdateEnvironmentVariables(env));
    dispatch(EnvironmentVariable.actions.resetAndLoadCollection());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(Domains));
